export enum IrisDmsSidebarTabType {
  Details = 'details',
  Links = 'links',
  History = 'history',
  Permissions = 'permissions',
  Attachments = 'attachments',
}
